import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle, Phone } from "lucide-react";
import { Reveal } from "@/components/motion";
import { CONTACT } from "@/data/site";

export default function CTABanner() {
  return (
    <section className="dq-container">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-dq-ink px-6 py-16 text-center sm:px-12 lg:py-24">
          <div className="pointer-events-none absolute -left-24 -top-24 h-80 w-80 rounded-full bg-dq-orange/30 blur-3xl" aria-hidden="true" />
          <div className="pointer-events-none absolute -bottom-28 -right-16 h-80 w-80 rounded-full bg-dq-orange/20 blur-3xl" aria-hidden="true" />
          <img src="/generated/cta.png" alt="" aria-hidden="true"
            className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.14]" loading="lazy" />
          <div className="relative">
            <p className="label-eyebrow mb-5 text-dq-orange">Ready to grow?</p>
            <h2 className="mx-auto max-w-3xl font-display text-4xl font-extrabold leading-[1.08] tracking-tighter text-white sm:text-5xl">
              Let&rsquo;s turn your business into the brand customers <span className="gradient-text">trust and choose</span>.
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-lg text-white/70">
              Book a free, no-obligation consultation. We&rsquo;ll map out exactly how to grow your leads.
            </p>
            <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link to="/contact" data-testid="cta-banner-consult" className="btn-primary text-base">
                Get Free Consultation <ArrowRight className="h-5 w-5" />
              </Link>
              <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="cta-banner-whatsapp"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 bg-white/5 px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-white/10">
                <MessageCircle className="h-5 w-5 text-[#25D366]" /> Chat on WhatsApp
              </a>
            </div>
            <a href={`tel:${CONTACT.phoneRaw}`} className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-white/50 hover:text-white">
              <Phone className="h-4 w-4" /> {CONTACT.phone}
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
